// @flow
import { accountState } from '@modules/account'
import { apiState } from '@modules/api'
import { appshellState } from '@modules/appshell'
import { authState } from '@modules/auth'
import { cartState } from '@modules/cart'
import { checkoutState } from '@modules/checkout'
import { productState } from '@modules/product'
import { staticState } from '@modules/staticPages'
import { appState } from '../appState'

export const defaultState: Object = {
  account: accountState,
  api: apiState,
  appshell: appshellState,
  auth: authState,
  cart: cartState,
  checkout: checkoutState,
  product: productState,
  staticPages: staticState,
  app: appState
}

export const getInitialState = (preloadedState: Object = {}): Object => ({
  ...preloadedState,
  ...defaultState
})
